var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name-forbidden-container"},[_c('h3',[_vm._v(_vm._s(_vm.domainName)+".eth "+_vm._s(_vm.$t('dapps.ensNotAvailable'))+"!")]),_c('interface-bottom-text')],1)}
var staticRenderFns = []

export { render, staticRenderFns }